// extracted by mini-css-extract-plugin
module.exports = {"mediumFormWidth":"form_mediumFormWidth__WPMDr"};